import A11yDialog from 'a11y-dialog';
import focusTrap from 'focus-trap';

const defaults = {
  navOpenClass: 'js-nav-open',
  offCanvasOpenClass: 'js-off-canvas-open',
  menuClass: '.js-menu',
  menuToggleClass: '.js-menu-toggle',
  offCanvasClass: '.js-off-canvas',
  offCanvasToggleClass: '.js-off-canvas-toggle',
  offCanvasOverlayClass: '.js-off-canvas-overlay',
  offCanvasCloseSelector: '[data-off-canvas-close]',
  hiddenClass: 'is-hidden',
  visibleClass: 'is-visible',
  mainSelector: 'main',
  searchDialogSelector: 'search-dialog',
  languageSwitcherSelector: 'language-switcher'
};

class SiteHeader {
  constructor (element) {
    this.header = element;
    this.options = defaults;
    this.nav = element.querySelector(this.options.menuClass);
    this.navToggle = element.querySelector(this.options.menuToggleClass);
    this.offCanvas = element.querySelector(this.options.offCanvasClass);
    this.offCanvasOverlay = element.querySelector(this.options.offCanvasOverlayClass);
    this.offCanvasToggle = element.querySelector(this.options.offCanvasToggleClass);
    this.offCanvasClose = element.querySelector(this.options.offCanvasCloseSelector);
    this.mainSection = document.getElementById(this.options.mainSelector);
    this.languageSwitcher = document.getElementById(this.options.languageSwitcherSelector);
    this.dialog = document.getElementById(this.options.searchDialogSelector);

    if (this.offCanvas) {
      this.trapFocus = focusTrap(this.offCanvas);
    }
  }

  ariaHidden (menu, toggle) {
    menu.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
  }

  ariaVisible (menu, toggle) {
    menu.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
  }

  hideMenu () {
    this.ariaHidden(this.nav, this.navToggle);
    this.nav.classList.add(this.options.hiddenClass);
    document.documentElement.classList.remove(this.options.navOpenClass);
  }

  showMenu () {
    this.ariaVisible(this.nav, this.navToggle);
    this.nav.classList.remove(this.options.hiddenClass);
    document.documentElement.classList.add(this.options.navOpenClass);
  }

  toggleMenu () {
    if (this.nav.classList.contains(this.options.hiddenClass)) {
      this.showMenu();
    } else {
      this.hideMenu();
    }
  }

  hideOffCanvas () {
    this.ariaHidden(this.offCanvas, this.offCanvasToggle);
    this.offCanvas.classList.remove(this.options.visibleClass);
    this.trapFocus.deactivate();
    document.documentElement.classList.remove(this.options.offCanvasOpenClass);
  }

  showOffCanvas () {
    this.ariaVisible(this.offCanvas, this.offCanvasToggle);
    this.offCanvas.classList.add(this.options.visibleClass);
    this.trapFocus.activate();
    document.documentElement.classList.add(this.options.offCanvasOpenClass);
  }

  addDialogs () {
    if (this.languageSwitcher) {
      const languageSwitcherInit = new A11yDialog(this.languageSwitcher, this.mainSection); // eslint-disable-line no-unused-vars
    }

    if (this.dialog) {
      const dialogInit = new A11yDialog(this.dialog, this.mainSection); // eslint-disable-line no-unused-vars
    }
  }

  addEventListeners () {
    if (this.navToggle) {
      this.navToggle.addEventListener('click', () => {
        this.toggleMenu();
      });
    }

    if (this.offCanvas && this.offCanvasToggle) {
      this.offCanvasToggle.addEventListener('click', () => {
        this.showOffCanvas();
      });

      this.offCanvasClose.addEventListener('click', () => {
        this.hideOffCanvas();
      });

      this.offCanvasOverlay.addEventListener('click', () => {
        this.hideOffCanvas();
      });

      this.offCanvas.addEventListener('keydown', (event) => {
        if (event.keyCode === 27) {
          this.hideOffCanvas();
        }
      });
    }
  }

  init () {
    if (this.nav && window.innerWidth < 993) {
      this.hideMenu();
    }

    this.addEventListeners();
    this.addDialogs();
  }
}
export default SiteHeader;
